import { Avatar as ChakraAvatar, type AvatarRootProps } from "@chakra-ui/react";

import { asSlotComponent } from "../internal/v3-slot";

const AvatarRoot = asSlotComponent(ChakraAvatar.Root);
const AvatarImage = asSlotComponent(ChakraAvatar.Image);
const AvatarFallback = asSlotComponent(ChakraAvatar.Fallback);

export type AvatarProps = AvatarRootProps & {
  name?: string;
  src?: string;
};

function Avatar({ name, src, fontSize, ...props }: AvatarProps) {
  return (
    <AvatarRoot fontSize={fontSize} {...props}>
      {src ? <AvatarImage src={src} alt={name} /> : null}
      <AvatarFallback name={name} fontSize={fontSize} />
    </AvatarRoot>
  );
}

export { Avatar };
